import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import { ClarityEvents } from '../../../../../lib/clarity/types/clarityEvents.types';
import { captureEvent } from '../../../../../lib/clarity/utils/captureEvent.utils';
import { useApplicationContext } from '../../../../../modules/context/ApplicationContext/ApplicationContext';
import { Brand } from '../../../../../modules/context/ApplicationContext/applicationContext.types';
import useAppEnvironment from '../../../../../modules/context/ApplicationContext/hooks/useAppEnvironment/useAppEnvironment';
import useEnterBrand from '../../../../../modules/context/ApplicationContext/hooks/useEnterBrand/useEnterBrand';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { UseBrandSelectorReturn } from './useBrandSelector.types';

export const useBrandSelector = (): UseBrandSelectorReturn => {
  const { state, removeSelectedBrand } = useApplicationContext();
  const { applyStoreEnvironment } = useAppEnvironment();
  const { enterBrand } = useEnterBrand();
  const { translate } = useTranslation();
  const history = useHistory();
  const { handleMessage } = snackbarStore;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onClose = () => setAnchorEl(null);

  const isInBrandEnvironment = Boolean(state.brand);
  const storeName = state.user?.store?.name ?? '';
  const storeLogoUrl = state.user?.store?.logoUrl;
  const storeInitial = storeName ? storeName[0].toUpperCase() : '';

  const onBrandClick = (brand: Brand) => {
    captureEvent(ClarityEvents.CLICKED_HEADER_BRAND_SELECTOR);
    enterBrand(brand);
    onClose();
  };

  const onGoToStore = () => {
    captureEvent(ClarityEvents.CLICKED_BACK_TO_STORE);
    removeSelectedBrand();
    applyStoreEnvironment();
    history.push('/');
    handleMessage({ type: 'info', message: translate(LangEnum.BRAND_STORE_ENVIRONMENT_MESSAGE) });
    onClose();
  };

  return {
    buttonProps: {
      onClick: (e) => {
        captureEvent(ClarityEvents.CLICKED_BRAND_SELECTOR);
        setAnchorEl(e.currentTarget);
      },
    },
    menuProps: {
      anchorEl,
      onClose,
      isInBrandEnvironment,
      storeName,
      storeLogoUrl,
      storeInitial,
      brands: state.brands,
      currentBrandId: state.brand?.id,
      onBrandClick,
      onGoToStore,
    },
  };
};
